import AttendanceSequenceService from "../../../../../services/reports/attendance-sequence-service.js";

export default function ReportContent({data, boName, onOpenModal, tableColumns}) {
    const address = (item) => (
        <>
            {item.attendance_factplace}
            {item.attendance_factplace && <br />}
            {[item.attendance_factstreet, item.attendance_factnumber].filter(Boolean).join(", ")}
            {item.attendance_factneighborhood &&
            (item.attendance_factstreet || item.attendance_factplace) ? " - " : ""}
            {item.attendance_factneighborhood}
            {item.attendance_sector && ` (${item.attendance_sector})`}
        </>
    );

    const columns = [
        {
            id: "protocol",
            render: (item) => (
                <>
                    <a href={AttendanceSequenceService.attendanceHref(item.attendance_id)} target="_blank" className="print:!text-black">
                        {item.attendance_protocol ?? "Sem protocolo"}
                    </a>
                    {item.schedule_id != null && (
                        <>
                            <br />
                            <b>Agendado</b>
                        </>
                    )}
                </>
            ),
        },
        {
            id: "dispatch",
            render: (item) =>
                item.dispatch_id ? (
                    <a href={AttendanceSequenceService.dispatchHref(item.dispatch_id)} target="_blank" className="print:!text-black">
                        {item.dispatch_numbercheckbook ?? "Sem talão"}
                    </a>
                ) : (
                    ""
                ),
        },
        {
            id: "bo",
            render: (item) =>
                item.dispatch_occurrencenumber ? (
                    <a href={AttendanceSequenceService.boHref(item.dispatch_occurrencenumber,)} target="_blank" className="print:!text-black">
                        {item.dispatch_occurrencenumber}
                    </a>
                ) : (
                    ""
                ),
        },
        {
            id: "start",
            render: (item) => (
                <>
                    {item.attendance_start ?? ""}
                    {item.attendance_end && (
                        <>
                            <br />
                            {item.attendance_end}
                        </>
                    )}
                    {item.attendance_firstuser && (
                        <>
                            <br />
                            {`(Cadastrado por ${item.attendance_firstuser})`}
                        </>
                    )}
                </>
            ),
        },
        {
            id: "update",
            render: (item) => (
                <>
                    {item.attendance_systemupdate ?? ""}
                    <br />
                    {item.attendance_lastuser ? `(Alterado por ${item.attendance_lastuser})` : ""}
                </>
            ),
        },
        {
            id: "requester",
            render: (item) => (
                <>
                    {item.attendance_contactname ?? ""}
                    {item.attendance_contactname !== "ANÔNIMO" &&
                        item.attendance_contactphone && (
                            <>
                                <br />
                                {item.attendance_contactphone}
                            </>
                        )}
                </>
            ),
        },
        { id: "channel", render: (item) => item.attendance_channel ?? "" },
        { id: "nature", render: (item) => item.attendance_nature ?? "" },
        { id: "status", render: (item) => item.attendance_statusname ?? "" },
        {
            id: "transcription",
            className: "transcription cursor-pointer text-[#0895e5] print:text-black break-all!",
            title: "Clique para ver a transcrição completa",
            onClick: (item) => onOpenModal?.(item),
            render: (item) => item.attendance_transcription ?? "",
        },
        { id: "address", render: address },
        { id: "finalObservation", render: (item) => item.attendance_finalobservation ?? "" },
    ];

    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    const exportColumns = [
        {id: "protocol", visibility: "protocol", label: "Protocolo", render: (item) => item.attendance_protocol ?? ""},
        {id: "dispatch", visibility: "dispatch", label: "Despacho", render: (item) => item.dispatch_id ? item.dispatch_numbercheckbook ?? "Sem talão" : ""},
        {id: "bo", visibility: "bo", label: boName, render: (item) => item.dispatch_occurrencenumber ?? ""},
        {id: "scheduled", visibility: "protocol", label: "Agendado", render: (item) => item.schedule_id != null ? "SIM" : "NÃO"},
        {id: "attendanceStart", visibility: "start", label: "D/H inicial", render: (item) => item.attendance_start ?? ""},
        {id: "attendanceEnd", visibility: "start", label: "D/H final", render: (item) => item.attendance_end ?? ""},
        {id: "attendanceFirstUser", visibility: "start", label: "Cadastrado por", render: (item) => item.attendance_firstuser ?? ""},
        {id: "attendanceUpdate", visibility: "update", label: "D/H última modificação", render: (item) => item.attendance_systemupdate ?? ""},
        {id: "attendanceLastUser", visibility: "update", label: "Alterado por", render: (item) => item.attendance_lastuser ?? ""},
        {id: "requester", visibility: "requester", label: "Solicitante", render: (item) => item.attendance_contactname ?? ""},
        {id: "phone", visibility: "requester", label: "Telefone", render: (item) => item.attendance_contactphone ?? ""},
        {id: "channel", visibility: "channel", label: "Canal", render: (item) => item.attendance_channel ?? ""},
        {id: "nature", visibility: "nature", label: "Natureza", render: (item) => item.attendance_nature ?? ""},
        {id: "status", visibility: "status", label: "Status", render: (item) => item.attendance_statusname ?? ""},
        {id: "transcription", visibility: "transcription", label: "Transcrição", render: (item) => item.attendance_transcription ?? ""},
        {id: "place", visibility: "address", label: "Local pré-cadastrado", render: (item) => item.attendance_factplace ?? ""},
        {id: "street", visibility: "address", label: "Endereço", render: (item) => item.attendance_factstreet ?? ""},
        {id: "number", visibility: "address", label: "Número", render: (item) => item.attendance_factnumber ?? ""},
        {id: "neighborhood", visibility: "address", label: "Bairro", render: (item) => item.attendance_factneighborhood ?? ""},
        {id: "crossroads", visibility: "address", label: "Cruzamento", render: (item) => item.attendance_factcrossroads ?? ""},
        {id: "sector", visibility: "address", label: "Setor", render: (item) => item.attendance_sector ?? ""},
        {id: "finalObservation", visibility: "finalObservation", label: "Observação final", render: (item) => item.attendance_finalobservation ?? ""},
    ];

    const visibleExportColumns = exportColumns.filter(
        (column) => tableColumns?.[column.visibility]?.visible !== false,
    );

    const getRowKey = (_, index) => `attendance-row-${index}`;

    return (
        <>
            {visibleColumns.length ? (
                <table id="attendance-sequence-data" className="table report-table" sheet-name="Sequência de atendimentos">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map((column) => (
                                <th key={column.id}>
                                    {column.id === "bo" ? boName : tableColumns[column.id].label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {data.map((item, index) => (
                            <tr key={getRowKey(item, index)} className="table-break-word">
                                {visibleColumns.map((column) => (
                                    <td key={column.id} className={column.className} title={column.title} onClick={() => column.onClick?.(item)}>
                                        {column.render(item)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <table id="attendance-sequence-export-data" className="export-data hidden" sheet-name="Sequência de atendimentos">
                <thead>
                    <tr>
                        {visibleExportColumns.map((column) => (
                            <th key={`export-header-${column.id}`}>{column.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={`attendance-export-row-${index}`}>
                            {visibleExportColumns.map((column) => (
                                <td key={`export-cell-${column.id}`}>{column.render(item)}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div id="chart-tables"/>
        </>
    );
}